// All needed imports
import { SelectModel } from '../../core/models/select.model';
import { Numbers } from 'src/app/utils/constants';
import { formConfigCommond } from 'src/app/utils/form.utils';
import { commonParticularDataLegal, setDateFormConfig } from 'src/app/utils/form-utils-extended';
import { CalendarBaseModel } from 'src/app/core/models/calendar-base.model';
import { setSelectModel, setSelectOptions, setSelectValue } from 'src/app/utils/labels.utils';

/**
 * set the LITERAL_TEXT value with the form2 value
 * The value is sportTravelAsistance
 */
const LITERAL_TEXT = 'sportTravelAsistance';
const DATE = new CalendarBaseModel(setDateFormConfig(LITERAL_TEXT));

// PARTICULAR_DATA object
const PARTICULAR_DATA = {
  searchSport: new SelectModel(
    setSelectModel([LITERAL_TEXT, 'searchSport'],
    setSelectValue('form1.country-destiny', 'form1.country-destiny.error' , 'label_size_7'),
    setSelectOptions('', '', [], [])
    )
  ),
  // Sports attribute
  sports: new SelectModel(
    setSelectModel([LITERAL_TEXT, 'sports'],
    setSelectValue('deporte.sport.label', 'deporte.sport.error', 'label_size_7'),
    setSelectOptions('', '', null, [])
    )
  ),
  ...commonParticularDataLegal(LITERAL_TEXT, DATE, 'form1')
};

/**
 * Export the obj to be used in the angular components app
 */
export const FORM_CONFIG = {
  ...formConfigCommond(LITERAL_TEXT, Numbers.number6),
  ...PARTICULAR_DATA
};

